import React from "react";
import Navbar from "./components/Navbar";
import Allroutes from "./router/Pages";
import { BrowserRouter } from "react-router-dom";
import { useState } from "react";

const App = () => {
  const[is_translated,setIs_Translated] = useState(false)
  return (
    <BrowserRouter>
      <Navbar is_translated={is_translated} />
      <Allroutes is_translated={is_translated} />
    </BrowserRouter>
  );
};

export default App;
